<!--
 * @Author: weijinpeng
 * @LastEditors: weijinpeng
 * @Date: 2024-03-01 14:10:38
 * @LastEditTime: 2024-06-13 16:33:52
 * @Description: 
-->
<template>
    <div class="progess">
        

        <!-- 左侧区间 -->
        <div class="progess-left" :class="centerNum == 0 ? 'wid100' : ''" :id="name+'left1'">
            <!-- 左侧竖线 -->
            <div class="progess-left-leftLine"></div>
            <!-- 左侧内容 -->
            <div class="progess-left-txt progess-left-left_p">{{minScore}}</div>
            <div class="progess-left-txt progess-left-left_p_b">{{maxEmiss}}</div>
            <!-- 左侧区间块 -->
            <div class="widleft background-6"></div>
            <!-- 分区竖线 -->
            <div class="progess-left-centerLine" :class="centerNum == 0 ? 'blue' : ''"></div>
            <!-- 分区内容 -->
            <div class="progess-left-txt progess-left-right_p">{{centerScore}}</div>
            <div class="progess-left-txt progess-left-right_p_b">{{minEmiss}}</div>

            <!-- 三角 -->
            <div :id="name+'left'" class="progess-left-btm_p">
                <div class="num_txt">{{ Math.round(leftScore) || 0 }}</div>
                <div class="sj"></div>
                <!-- <div class="txt_center">{{leftEmiss}}</div> -->
            </div>
        </div>

        <!-- 右侧区间 -->
        <div class="progess-right" v-if="centerNum == 1" :id="name+'right1'">
            <!-- 右侧区间右竖线 -->
            <div class="progess-right-leftLineMin"></div>
            <!-- 右侧区间左侧内容 -->
            <div class="progess-right-txt progess-right-left_p">{{rightMinScore}}</div>
            <div class="progess-right-txt progess-right-left_p_b">{{rightMinTxt}}</div>

            <!-- 右侧区间块 -->
            <div class="wid background-5"></div>

            <!-- 右侧区间左竖线 -->
            <div class="progess-right-rightLineMin"></div>
            <!-- 右侧区间右侧内容 -->
            <div class="progess-right-txt progess-right-right_p">{{rightMaxScore}}</div>
            <div class="progess-right-txt progess-right-right_p_b">{{rightMaxTxt}}</div>

            <!-- 右侧竖线 -->
            <div class="progess-right-rightLine"></div>
            <!-- 分区内容 -->
            <div class="progess-left-txt progess-right-right">{{maxScore}}</div>
            <!-- 三角 -->
            <div :id="name+'right'" class="progess-right-btm_p">
                <div class="num_txt">{{ Math.round(rightScore) || 0 }}</div>
                <div class="sj"></div>
            </div>

        </div>
        
        
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
export default {
    name: 'newPro',
    props:{
        // 元素id
        name:{
            type:String,
            default:() => null
        },
        // 区块数量
        centerNum:{
            type:Number,
            default:() => 5
        },
        // 最小分数
        minScore:{
            type:Number,
            default:() => 30
        },
        // 区间分数
        centerScore:{
            type:Number,
            default:() => 100
        },
        // 左侧得分
        leftScore:{
            type:Number,
            default:() => 0
        },
        // 左侧排放
        // leftEmiss:{
        //     type:String,
        //     default:() => ''
        // },
        // 左侧最大排放
        maxEmiss:{
            type:String,
            default:() => ''
        },
        // 左侧最小排放
        minEmiss:{
            type:String,
            default:() => ''
        },
        // 右侧最大分数
        maxScore:{
            type:Number,
            default:() => 100
        },
        // 右侧区间最小分数
        rightMinScore:{
            type:Number,
            default:() => 0
        },
        // 右侧区间最大分数
        rightMaxScore:{
            type:Number,
            default:() => 100
        },
        // 右侧区间得分
        rightScore:{
            type:Number,
            default:() => 0
        },
        // 右侧区间文案1
        rightMinTxt:{
            type:String,
            default:() => ''
        },
        // 右侧区间文案2
        rightMaxTxt:{
            type:String,
            default:() => ''
        },
    },
    setup(props) {
        const data = reactive({
            // 元素id
            name:props.name,
            // 区块数量
            centerNum:props.centerNum,
            // 最小分数
            minScore:props.minScore,
            // 区间分数
            centerScore:props.centerScore,
            // 左侧得分
            leftScore:props.leftScore,
            // 左侧排放
            // leftEmiss:props.leftEmiss,
            // 左侧最大排放
            maxEmiss:props.maxEmiss,
            // 左侧最小排放
            minEmiss:props.minEmiss,
            // 右侧最大分数
            maxScore:props.maxScore,
            // 右侧区间最小分数
            rightMinScore:props.rightMinScore,
            // 右侧区间最大分数
            rightMaxScore:props.rightMaxScore,
            // 右侧区间得分
            rightScore:props.rightScore,
            // 右侧区间文案1
            rightMinTxt:props.rightMinTxt,
            // 右侧区间文案2
            rightMaxTxt:props.rightMaxTxt,
        })
        // 改变进度条位置
        const changeProgess = () => {
            // 获取分数与三角的宽度
            const progess = document.getElementById(data.name + 'left')
            const width = progess.offsetWidth;
            // 获取进度条的宽度
            const progess1 = document.getElementById(data.name + 'left1')
            const width1 = progess1.offsetWidth;
            // 根据分数计算占比
            const cen = data.leftScore / data.centerScore * (width1 - width)
            // 根据占比动态左偏移
            const leftOffset = `${cen}px`;
            progess.style.left = leftOffset;
        }
        // 改变进度条位置
        const changeProgess1 = () => {
            // 获取分数与三角的宽度
            const progessRight = document.getElementById(data.name + 'right')
            const progessWidth = progessRight.offsetWidth;
            // 获取进度条的宽度
            const progessRight1 = document.getElementById(data.name + 'right1')
            const progessWidth1 = progessRight1.offsetWidth;
            // 根据分数计算占比
            const cenRight = data.rightScore / data.rightMaxScore * (progessWidth1 - progessWidth)
            // 根据占比动态左偏移
            const rightOffset = `${cenRight}px`;
            progessRight.style.left = rightOffset;
        }
        onBeforeMount(() => {
            
        })
        onMounted(() => {
            changeProgess()
            if(data.centerNum !== 0){
                changeProgess1()
            }
        })
        return {
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.progess{
    width: 100%;
    display: flex;
    align-items: center;
    &-left{
        display: flex;
        align-items: center;
        position: relative;
        width: calc(100% - 123px);
        &-txt{
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            line-height: 1.2;
            max-width: 300px;
        }
        &-left_p{
            position: absolute;
            left: 0;
            top: -30px;
        }
        &-left_p_b{
            position: absolute;
            left: 0;
            bottom: -30px;
        }
        &-right_p{
            position: absolute;
            right: 0;
            top: -30px;
        }
        &-right_p_b{
            position: absolute;
            right: 0;
            text-align: right;
            bottom: -30px;
        }
        &-leftLine{
            width: 2px;
            height: 120px;
            background: #FF7334;
        }
        &-centerLine{
            width: 2px;
            height: 120px;
            background: #FF7334;
        }
        &-btm_p{
            position: absolute;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .num_txt{
                margin-bottom: 20px;
                font-weight: bold;
                font-size: 20px;
                line-height: 1;
                color: #00BAF4;
                text-align: left;
                transform: translateY(-3px);
            }
            .num_txt_s{
                font-weight: bold;
                font-size: 12px;
                color: #00BAF4;
                line-height: 14px;
            }
            .txt_center{
                font-weight: bold;
                font-size: 12px;
                color: #00BAF4;
                line-height: 14px;
            }
            .sj{
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-bottom: 16px solid #00BAF4;
            }
        }
    }
    &-right{
        display: flex;
        align-items: center;
        position: relative;
        width: 121px;
        &-rightLine{
            width: 2px;
            height: 120px;
            background: #013C89;
        }
        &-leftLineMin{
            width: 1px;
            height: 60px;
            background: #FF7334;
            margin-left: 2px;
        }
        &-rightLineMin{
            width: 1px;
            height: 60px;
            background: #FF7334;
            margin-right: 2px;
        }
        &-txt{
            font-size: 12px;
            color: #333333;
            transform: scale(0.67);
            line-height: 1.2;
        }
        &-left_p{
            position: absolute;
            left: 0;
            top: 14px;
        }
        &-left_p_b{
            position: absolute;
            left: -5px;
            bottom:4px;
            max-width: 40px;
        }
        &-right_p{
            position: absolute;
            right: 0;
            top: 14px;
        }
        &-right_p_b{
            position: absolute;
            right: -10px;
            bottom:4px;
            max-width: 100px;
            text-align: right;
        }
        &-right{
            position: absolute;
            right: 0px;
            top:-30px;
        }
        &-btm_p{
            position: absolute;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .num_txt{
                margin-bottom: 20px;
                font-weight: bold;
                font-size: 20px;
                color: #00BAF4;
                text-align: left;
                line-height: 1;
                transform: translateY(-3px);
            }
            .num_txt_s{
                font-weight: bold;
                font-size: 12px;
                color: #00BAF4;
                line-height: 14px;
            }
            .txt_center{
                font-weight: bold;
                font-size: 12px;
                color: #00BAF4;
                line-height: 14px;
            }
            .sj{
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-bottom: 16px solid #00BAF4;
            }
        }
    }
    
    .wid{
        width: 100%;
        height: 14px;
        margin: 0px 2px;
    }
    .wid100{
        width: 100% !important;
    }
    .widleft{
        width: 100%;
        height: 14px;
    }
    .background-1 {
        background: #FF7334;
    }

    .background-2 {
        background: #F3B000;
    }

    .background-3 {
        background: #B0D900;
    }

    .background-4 {
        background: #00BAF4;
    }

    .background-5 {
        background: #013C89;
    }
    .background-6 {
        background: linear-gradient( 90deg, #FF7334 0%, #F4DE69 50%, #00BAF4 100%);
    }
    .blue{
        background: #013C89 !important;
    }
    
}



</style>